import { Button, Grid } from '@mui/material';
import AnimateButton from './AnimateButton';
import './AuthButton.css';

const AuthButton = () => {
  const idportURL = process.env.REACT_APP_ID_PORTAL_URL;
  const handleSignOn = () => {
    if (idportURL) {
      window.location.href = idportURL;
    } else {
      console.error('ID Portal URL is not configured');
    }
  };

  return (
    <Grid container direction="column" justifyContent="center" spacing={2}>
      <Grid item xs={12} className="auth-button-item">
        <AnimateButton>
          <Button
            onClick={handleSignOn}
            size="large"
            variant="outlined"
            className="btn-custom"
          >
            SINGLE SIGN ON
          </Button>
        </AnimateButton>
      </Grid>
    </Grid>
  );
};

export default AuthButton;